// extracted by mini-css-extract-plugin
export var danger = "_3j-6";
export var lightPink = "_3j-a";
export var medium = "_3j-j";
export var nearSquare = "_3j-m";
export var neutralBlue = "_3j-8";
export var neutralYellow = "_3j-7";
export var noCapitalize = "_3j-1";
export var normal = "_3j-2";
export var pill = "_3j-0";
export var primary = "_3j-3";
export var primaryLight = "_3j-4";
export var shadow = "_3j-n";
export var small = "_3j-k";
export var solidBlack = "_3j-i";
export var solidGreen = "_3j-d";
export var solidLightBlue = "_3j-f";
export var solidNavy = "_3j-e";
export var solidOrange = "_3j-h";
export var solidPink = "_3j-g";
export var solidRed = "_3j-b";
export var solidWhite = "_3j-9";
export var solidYellow = "_3j-c";
export var success = "_3j-5";
export var xsmall = "_3j-l";